import React, { Children } from 'react';
import { Hero } from '../components/Hero';
import { ContentSection } from '../components/ContentSection';
import { EventSection } from '../components/EventSection';
import { FlyerSection } from '../components/FlyerSection';
import { PartnersSection } from '../components/PartnersSection';
import { PartnerForm } from '../components/PartnerForm';
export function HomePage() {
  return <main data-id="element-198">
      <Hero data-id="element-199" />

      <ContentSection id="celebrate" title="Celebrate" text="The Good Father Project recognizes wonderful fathers and father-figures in our communities through essays written by their children. Children submit essays to their schools, which are read and judged by community partners, and winning essays are recognized during a special event." imageSrc="https://cdn.magicpatterns.com/uploads/oGUhJaWrJtCxPVinrhxexe/494644419-9374528632659469-3529350465437840350-n.jpg" imageAlt="Boy reading essays on display" bgColor="bg-gray-50" data-id="element-200" />

      <ContentSection id="honor" title="Honor" text={<>
            The Good Father Project was first launched in Mongolia during{' '}
            <a href="https://www.youtube.com/watch?v=POBzwObdprI" target="_blank" rel="noopener noreferrer" className="text-[#c06a2b] hover:underline font-medium" data-id="element-202">
              Peace Corps
            </a>{' '}
            service. Fathers were honored on International Children's Day,
            celebrating their roles in the lives of children and families. We're
            thrilled to bring it to our community to honor fathers and
            father-figures within Harrisonburg and Rockingham at the{' '}
            <a href="https://www.downtownharrisonburg.org/best-weekend-ever" target="_blank" rel="noopener noreferrer" className="text-[#c06a2b] hover:underline font-medium" data-id="element-203">
              Best Weekend Ever
            </a>
            .
          </>} imageSrc="https://cdn.magicpatterns.com/uploads/3eByi8hQ3ii73YGaPnYjuR/494055202-9374529915992674-2541877543127810459-n_orig.jpg" imageAlt="Father receiving award with daughter" reversed={true} data-id="element-201" />

      <ContentSection id="support" title="Support" text="Fathers and father-figures are encouraged to support one another, start clubs and join initiatives that elevate their communities and help build healthy families. Our current partners include the Harrisonburg Rockingham Fatherhood Initiative in Virginia and the Peace Corps in Mongolia." imageSrc="https://cdn.magicpatterns.com/uploads/q3EERCP2kB5VpFhnu8vzZF/BWE_FULLSET250-118.jpg.webp" imageAlt="Father carrying child on shoulders at community event" bgColor="bg-gray-50" data-id="element-204" />

      <EventSection data-id="element-205" />

      <FlyerSection data-id="element-206" />

      <PartnersSection data-id="element-207" />

      <PartnerForm data-id="element-208" />
    </main>;
}